/**
 * Helper compartilhado pra rotas DNS que retornam 202 + task_id quando
 * algo é enfileirado pra worker. Exibe toast + abre HUD instantâneo
 * via window event 'task-enqueued'.
 *
 * Compatível com:
 *   - novo formato: { task_id, status: "queued" } (status 202)
 *   - formato antigo: { nodes: [{name, result}, ...] }
 *   - erro: { error: "..." }
 *   - sem mudança: { status: "no_changes" } ou similar
 */
export function handleQueuedResponse(res, notify, opts = {}) {
    const data = res?.data || {};
    const successMessage = opts.successMessage || 'Operação enfileirada — acompanhe na fila';
    const noChangesMessage = opts.noChangesMessage || 'Nenhuma alteração — DNS não atualizado';

    // Erro explícito
    if (data.error) {
        notify.setNotify({ open: true, message: data.error, severity: 'error' });
        return { ok: false, error: data.error };
    }

    // Novo formato: 202 com task_id
    if (data.task_id) {
        try { window.dispatchEvent(new Event('task-enqueued')); } catch (_) {}
        notify.setNotify({ open: true, message: successMessage, severity: 'info' });
        return { ok: true, queued: true, task_id: data.task_id };
    }

    // Sem mudança
    if (data.status === 'no_changes') {
        notify.setNotify({ open: true, message: noChangesMessage, severity: 'warning' });
        return { ok: true, queued: false };
    }

    // Formato antigo (compat — sem fila)
    if (data.nodes) {
        if (data.nodes.length === 0) {
            notify.setNotify({ open: true, message: noChangesMessage, severity: 'warning' });
            return { ok: true, queued: false };
        }
        const allOk = data.nodes.every(n => n.result === true || n.result === 1);
        const allFail = data.nodes.every(n => n.result === false || n.result === 0);
        const severity = allFail ? 'error' : (allOk ? 'success' : 'warning');
        const msg = data.nodes.map(n => `${n.name}: ${n.result === 1 || n.result === true ? 'OK' : 'Falhou'}`).join('\n');
        notify.setNotify({ open: true, message: msg, severity });
        return { ok: !allFail, queued: false };
    }

    // Default: assumimos sucesso
    notify.setNotify({ open: true, message: opts.fallbackMessage || successMessage, severity: 'success' });
    return { ok: true, queued: false };
}
